export default __webpack_public_path__ + "static/media/NakasetMap.f3da5778.jpg";